import React from 'react';
import { FadeIn } from './FadeIn';
import { Star } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    initials: 'MR',
    quote: 'Recuperé mis tardes. Tengo material listo para cada sesión y los informes los hago en la mitad del tiempo.',
    name: 'Martina R.',
    location: 'Buenos Aires',
    role: 'Psicopedagoga'
  }, {
    initials: 'JC',
    quote: 'Las Rutas de Intervención PRO me cambiaron la forma de planificar. Ahora sé exactamente qué trabajar primero.',
    name: 'Julieta C.',
    location: 'Rosario',
    role: 'Docente de apoyo'
  }, {
    initials: 'SV',
    quote: 'El banco de actividades es oro. Imprimo y aplico. Mis sesiones tienen más variedad y los chicos avanzan más.',
    name: 'Sofía V.',
    location: 'Córdoba',
    role: 'Psicopedagoga clínica'
  }];
  return <section className="pt-8 pb-12 px-4 max-w-6xl mx-auto" data-id="element-241">
      <FadeIn data-id="element-242">
        <h2 className="text-center font-display text-3xl md:text-4xl font-bold text-mint mb-8" data-id="element-243">
          Lo que dicen las profesionales que ya lo usan
        </h2>
      </FadeIn>

      <div className="grid md:grid-cols-3 gap-4" data-id="element-244">
        {testimonials.map((t, idx) => <FadeIn key={idx} delay={idx * 0.1} className="bg-surface p-4 rounded-xl shadow-sm border border-mint/10 relative" data-id="element-245">
            <div className="absolute -top-4 left-6 bg-mint text-black w-9 h-9 rounded-full flex items-center justify-center font-bold text-sm shadow-md" data-id="element-246">
              {t.initials}
            </div>
            <div className="flex gap-0.5 mb-2 mt-1" data-id="element-247">
              {[...Array(5)].map((_, i) => <Star key={i} size={12} className="fill-mint text-mint" data-id="element-248" />)}
            </div>
            <p className="text-white/80 italic text-sm mb-3 leading-snug" data-id="element-249">
              "{t.quote}"
            </p>
            <div className="border-t border-mint/10 pt-2" data-id="element-250">
              <p className="font-bold text-mint text-sm" data-id="element-251">{t.name}</p>
              <p className="text-xs text-white/50" data-id="element-252">
                {t.location} | {t.role}
              </p>
            </div>
          </FadeIn>)}
      </div>
    </section>;
}